'use es6';

import { PARTNER_ACCOUNT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import ObjectDefinitionRecord from '../ObjectDefinitionRecord';
const PartnerAccount = ObjectDefinitionRecord({
  hasAccess: (isUngated, hasScope) => isUngated('PartnerAccount:ObjectTypeRollout') && hasScope('partner-account-object-read'),
  objectTypeId: PARTNER_ACCOUNT_TYPE_ID,
  referenceObjectType: 'PARTNER_ACCOUNT_PROPERTIES'
});
export default PartnerAccount;